import axios, {AxiosResponse} from "axios";
import {CustomerTravelTime, CustomerTravelTimes} from "@/model/CustomerTravelTime";

const PATH = "/v2/customers";

export default {
    getCustomerTravelTimes (customerId: string): Promise<AxiosResponse<CustomerTravelTimes>> {
        return axios.get(`${PATH}/${customerId}/travel-times`);
    },
    updateCustomerTravelTimes (customerId: string, travelTimes: CustomerTravelTime[]): Promise<AxiosResponse<CustomerTravelTimes>> {
        return axios.put(`${PATH}/${customerId}/travel-times`, {travelTimes});
    }
};
